<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>

    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :inline="true"
          :model="form"
          label-width="200px"
          class="demo-form-inline"
          style="width: 900px"
        >
          <p>理货任务生成规则</p>
          <el-form-item label="规则起始时间:">
            <el-date-picker
              v-model="form.set_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <!--                    <el-form-item label="商家">-->
          <!--                        <el-select v-model="form.supply_ids" :remote-method="fetchSupply" multiple remote filterable @change="setSelect">-->
          <!--                            <el-option v-for="item in this.search_ops.supply" :value="item.supply_id" :label="item.supply_name"></el-option>-->
          <!--                        </el-select>-->
          <!--                        <el-select multiple filterable v-model="form.supply_ids"  style="width: 200px">-->
          <!--                            <el-option :label="item.supply_name" :value="item.supply_id" v-for="item in this.search_ops.supply"></el-option>-->
          <!--                        </el-select>-->
          <!--                    </el-form-item>-->
          <!--                    <el-form-item label="商品分类">-->
          <!--                        <el-cascader v-model="form.cat_id"  :options="this.search_ops.category" :props="props" clearable></el-cascader>-->
          <!--                    </el-form-item>-->
          <el-form-item label="点货人">
            <el-select
              v-model="form.admin_ids"
              multiple
              filterable
              style="width: 200px"
            >
              <el-option
                v-for="item in search_ops.admin"
                :key="item.admin_id"
                :label="item.admin_name"
                :value="item.admin_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="颜色">
            <el-select
              v-model="form.co_ids"
              multiple
              filterable
              style="width: 200px"
            >
              <el-option
                v-for="item in search_ops.colors"
                :key="item.co_id"
                :label="item.co_val"
                :value="item.co_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否带配件">
            <el-select v-model="form.is_parts" style="width: 200px">
              <el-option
                v-for="item in search_ops.is_suit"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="举报维度">
            <el-select
              v-model="form.storage_report_class_id"
              multiple
              filterable
              style="width: 200px"
            >
              <el-option label="无举报" value="-1"></el-option>
              <el-option label="全部举报类型(不含无举报)" value="0"></el-option>
              <el-option
                v-for="item in search_ops.storage_report"
                :key="item.class_id"
                :label="item.class_name"
                :value="item.class_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否套装">
            <el-select v-model="form.is_suit" style="width: 200px">
              <el-option
                v-for="item in search_ops.is_suit"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库来源">
            <el-select
              v-model="form.stock_source"
              multiple
              style="width: 200px"
            >
              <el-option
                v-for="item in search_ops.stock_source"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单个任务仓位数">
            <el-input
              v-model="form.space_num"
              placeholder="单个任务仓位数"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <el-row
          :span="24"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
          "
        >
          <el-col :span="1">商家：</el-col>
          <el-col :span="8" style="text-align: left">
            <el-select
              v-model="supply_id"
              :remote-method="fetchSupply"
              remote
              filterable
              @change="add_supply"
            >
              <el-option
                v-for="item in search_ops.supply"
                :key="item.supply_id"
                :value="item.supply_id"
                :label="item.supply_name"
              ></el-option>
            </el-select>
            <el-button type="success" style="" size="mini" @click="selectCat"
              >编辑分类</el-button
            >
          </el-col>
        </el-row>
        <div style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="select_supply"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="first_cat"
              label="商品一级分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="second_cat"
              label="商品二级分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="third_cat"
              label="商品三级分类"
              align="center"
            ></el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  style="color: red"
                  type="text"
                  size="small"
                  @click="delete_supply(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="选择分类" :visible.sync="cat_visible" width="30%" center>
      <el-form :model="form">
        <el-form-item label="商品分类">
          <el-cascader
            v-model="cat_ids"
            :options="search_ops.category"
            :props="props"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cat_visible = false">取 消</el-button>
        <el-button type="primary" @click="setCat">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "../wavepicking/components/HeaderTabs";
export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      props: { multiple: true, emitPath: false, checkStrictly: true },
      form: {},
      loading: false,
      tableLoading: false,
      url: "/erp/TallyTask/editTallyTaskSetting",
      filterFold: false,
      search_ops: {},
      default_supply: [],
      select_supply: [],
      supply_id: "",
      supply_ids: [],
      cat_visible: false,
      cat_ids: [],
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    selectCat() {
      if (this.supply_ids.length == 0) {
        return this.$message.error("请先选择商家");
      }
      this.cat_visible = true;
    },
    delete_supply(val) {
      this.select_supply.splice(this.select_supply.indexOf(val), 1);
      this.form.supply_ids.splice(
        this.form.supply_ids.indexOf(val.supply_id),
        1
      );
    },
    setCat() {
      let first_cat = "";
      let second_cat = "";
      let third_cat = "";
      this.search_ops.category.forEach((v) => {
        if (this.cat_ids.includes(v.value)) {
          if (first_cat) {
            first_cat = first_cat + "," + v.label;
          } else {
            first_cat = v.label;
          }
        }
        v.children.forEach((v2) => {
          if (this.cat_ids.includes(v2.value)) {
            if (second_cat) {
              second_cat = second_cat + "," + v2.label;
            } else {
              second_cat = v2.label;
            }
          }
          v2.children.forEach((v3) => {
            if (this.cat_ids.includes(v3.value)) {
              if (third_cat) {
                third_cat = third_cat + "," + v3.label;
              } else {
                third_cat = v3.label;
              }
            }
          });
        });
      });
      for (let key in this.select_supply) {
        if (this.supply_ids.includes(this.select_supply[key].supply_id)) {
          this.$set(this.select_supply[key], "first_cat", first_cat);
          this.$set(this.select_supply[key], "second_cat", second_cat);
          this.$set(this.select_supply[key], "third_cat", third_cat);
          this.$set(this.select_supply[key], "cat_ids", this.cat_ids);
        }
      }
      this.cat_visible = false;
    },
    handleSelectionChange(val) {
      let multipleSelection = [];
      for (let key in val) {
        multipleSelection[key] = val[key].supply_id;
      }
      this.supply_ids = multipleSelection;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http
        .get("/erp/TallyTask/getTallyTaskSetting", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.form = res.data.data.form;
            this.search_ops = res.data.data.search_ops;
            this.select_supply = res.data.data.supply_data;
            // this.default_supply = this.search_ops.supply;
          }
        });
    },
    submit() {
      let msg = "确认保存?";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$set(this.form, "supply_data", this.select_supply);
          this.$http.post(this.url, this.filteredForm).then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success("修改成功");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    add_supply(val) {
      this.search_ops.supply.forEach((v) => {
        if (v.supply_id == val) {
          if (!this.form.supply_ids.includes(val)) {
            this.select_supply.push({
              supply_id: v.supply_id,
              supply_name: v.supply_name,
            });
            this.form.supply_ids.push(v.supply_id);
          }
        }
      });
    },
    fetchSupply(e) {
      if (typeof e == "string" && e.length > 2) {
        this.$http
          .post("/erp/Common/selectSupply", { supply_name: e })
          .then((res) => {
            if (res.data.code != 200) {
              return this.$message.error(res.data.msg);
            }
            this.$set(this.search_ops, "supply", res.data.data);
            // this.setSelect();
          });
      }
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/TallyTaskSetting.vue